import {
  /* NEW SUBSCRIPTION FLOW */
  RECEIVED_PUBLIC_BRAINTREE_TOKEN,
  SELECT_PLAN,
  RECEIVED_PLAN_ID,
  RECEIVED_PAYMENT_ID,
  RECEIVED_CUSTOMER_ID,
  RECEIVED_NUMBER_OF_SUBSCRIBERS,
  CLEAN_UP_AFTER_SUCCESSFUL_SUBSCRIPTION,
} from '../actions';

const defaultState = {
  selectedPlan: '',
  publicBraintreeToken: '',
  planId: '',
  subscriptionId: '',
  customerId: '',
  quantity: 1,
};

export function dataSubscription(state = defaultState, action = null) {
  switch (action.type) {
    /* NEW SUBSCRIPTION FLOW */

    case RECEIVED_PUBLIC_BRAINTREE_TOKEN: {
      return Object.assign({}, state, { publicBraintreeToken: action.token });
    }
    case SELECT_PLAN: {
      return Object.assign({}, state, { selectedPlan: action.planId });
    }
    case RECEIVED_PLAN_ID: {
      return Object.assign({}, state, { planId: action.id });
    }
    case RECEIVED_PAYMENT_ID: {
      return Object.assign({}, state, { paymentId: action.id });
    }
    case RECEIVED_CUSTOMER_ID: {
      return Object.assign({}, state, { customerId: action.id });
    }
    case RECEIVED_NUMBER_OF_SUBSCRIBERS: {
      return Object.assign({}, state, {
        quantity: parseInt(action.quantity, 10),
      });
    }
    case CLEAN_UP_AFTER_SUCCESSFUL_SUBSCRIPTION: {
      return Object.assign({}, state, {
        paymentId: '',
        customerId: '',
        planId: '',
        quantity: 1,
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/dataSubscription.js